import React from 'react';
import { Info as InfoIcon } from 'react-feather';
import {
  JupiterTheme,
  EntitlementsTooltip,
} from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    companyLogoLabelRoot: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: 18,
    },
    specialTextStyle: {
      fontWeight: 700,
      margin: theme.spacing(0, 1),
    },
    infoIcon: {
      height: 20,
      width: 20,
      fontWeight: 500,
      cursor: 'pointer',
      transition: '300ms color ease-in-out',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
  });
});
interface CompanyLogoLabelProps {
  disabled: boolean;
}

const CompanyLogoLabel = ({ disabled }: CompanyLogoLabelProps) => {
  const classes = useStyles();
  return (
    <div className={classes.companyLogoLabelRoot}>
      Company Logo{` `}
      <span className={classes.specialTextStyle}>URL</span>
      {disabled && (
        <EntitlementsTooltip
          hasEntitlement={!disabled}
          prompt="Your Current JupiterOne plan does not include custom company logos."
        >
          {() => <InfoIcon className={classes.infoIcon} />}
        </EntitlementsTooltip>
      )}
    </div>
  );
};

export default CompanyLogoLabel;
